export default function checkValidColumn(column) {
    const def = column?.def?.toJS?.() ?? column?.def ?? column;

    if (['currency_id', 'email1'].includes(def.name)) {
        return true;
    }
    if (def.source === 'non-db' && def.type === 'varchar') {
        return false;
    }
    return def.type !== 'link';
}
